<template>
  <v-card width="400px" class="mt-5 mx-auto" color="grey darken-3">
    <v-card-title class="pb-0">
      <h3 style="color: white;">GO Admin Login</h3>
    </v-card-title>
    <v-spacer></v-spacer>
    <v-card-text>
      <!-- ──────────────────────────────────────────────────────────── -->
      <!-- Google Sign-In error states -->
      <!-- ──────────────────────────────────────────────────────────── -->
      <v-alert v-if="domainBlocked" type="warning" dense style="font-size:12px">
        Only <strong>@gooday.io</strong> accounts are allowed.
      </v-alert>

      <v-alert v-if="signInFailed" type="error" dense style="font-size:12px">
        Sign-in failed. Please try again.
      </v-alert>

      <v-alert v-if="disabledAdmin" type="error" dense style="font-size:12px">
        Your account has been disabled. Contact your administrator.
      </v-alert>

      <!-- ──────────────────────────────────────────────────────────── -->
      <!-- Pin entry shown after Google auth -->
      <!-- ──────────────────────────────────────────────────────────── -->
      <template v-if="googleDone">
        <p style="color: #D500F9; font-size:12px; margin-bottom: 4px;">
          <v-icon small color="#D500F9">mdi-check-circle-outline</v-icon>
          Signed in as <strong>{{ googleEmail }}</strong
          >. Enter your pin to continue.
        </p>
        <v-text-field
          label="Admin Pin Code"
          v-model="badgeNumber"
          prepend-icon="mdi-shield-key-outline"
          :append-icon="showPin ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="() => (showPin = !showPin)"
          :type="showPin ? 'password' : 'text'"
          dark
        />
        <p v-if="pinError" style="color: #FFC107; font-size:12px">
          <v-icon small color="#FFC107">mdi-alert</v-icon>
          Pin code not found. Please try again.
        </p>
      </template>

      <!-- ════════════════════════════════════════════════════════════ -->
      <!--  Phone/SMS authentication form (replaced with Google Sign-In) -->
      <!-- ════════════════════════════════════════════════════════════ -->
      <!-- <v-form>
        <v-text-field
          label="GO Admin phone number"
          prepend-icon="mdi-cellphone"
          v-model="phone"
          dark
          :error-messages="phoneErrors"
          required
          @input="$v.phone.$touch()"
          @blur="$v.phone.$touch()"
        />
        <span
          v-if="!phoneExists && okSignin && !showVerifyCode"
          style="color: #D500F9; font-size:12px">
          <v-icon small color="#D500F9">mdi-information-outline</v-icon>
          Tap Verify and wait for sign-in SMS code
        </span>
        <v-progress-linear
          v-if="okSignin && !phoneExists && !showVerifyCode"
          indeterminate
          rounded
          height="6"
          color="purple accent-3">
        </v-progress-linear>
        <span
          v-if="!phoneExists && okSignin && phoneSearched"
          style="color: #FFC107; font-size:12px">
          <v-icon small color="amber">mdi-alert</v-icon>
          This phone number is new to gdoadm system, contact admin for access!
        </span>
        <v-text-field
          v-if="showVerifyCode"
          label="Enter the SMS verification code you received"
          v-model="verifyCode"
          dark
        />
        <v-text-field
          v-if="showVerifyCode"
          label="Admin Pin Code"
          v-model="badgeNumber"
          :append-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="() => (value = !value)"
          :type="value ? 'password' : 'text'"
          dark
        />
        <span
          v-if="smsFailed"
          style="color: #FFC107; font-size:12px">
          <v-icon small color="#FFC107">mdi-alert</v-icon>
          SMS verification failed, check your phone number and try again
        </span>
      </v-form>
      <p
        v-if="verifyError"
        style="color: #FFC107; font-size:12px">
        Invalid SMS token, request a token again!
      </p> -->
    </v-card-text>

    <v-card-actions>
      <!-- ──────────────────────────────────────────────────────────── -->
      <!--  Google Sign-In button -->
      <!-- ──────────────────────────────────────────────────────────── -->
      <v-btn v-if="!googleDone" color="white" block :loading="loading" @click="signInWithGoogle">
        <v-icon left color="#4285F4">mdi-google</v-icon>
        Sign in with Google
      </v-btn>

      <v-btn
        v-if="googleDone"
        color="purple accent-3"
        dark
        block
        :loading="loading"
        :disabled="!badgeNumber"
        @click="confirmPin"
      >
        <v-icon left>mdi-login</v-icon>
        Enter
      </v-btn>

      <!-- ════════════════════════════════════════════════════════════ -->
      <!--  Phone/SMS auth buttons -->
      <!-- ════════════════════════════════════════════════════════════ -->
      <!-- <v-btn
        v-if="!showVerifyCode"
        color="white"
        type="submit"
        v-on:submit.prevent="smsAuthenticate"
        @click="smsAuthenticate"
        id="sign-in-button"
        :disabled="$v.$invalid">
        Verify Phone
      </v-btn>
      <v-btn
        v-if="showVerifyCode"
        color="white"
        @click="signIn">
        Sign In
      </v-btn> -->
    </v-card-actions>
  </v-card>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

// ════════════════════════════════════════════════════════════════════
//  vuelidate and firebaseAuthMixins (replaced with Google Sign-In)
// ════════════════════════════════════════════════════════════════════
// import { required, maxLength, minLength } from 'vuelidate/lib/validators';
// import { firebaseAuthMixins } from './mixins/firebaseAuth';

export default {
  //  mixins and validations
  // mixins: [firebaseAuthMixins],
  // validations: {
  //   phone: {
  //     required,
  //     minLen: minLength(13),
  //     maxLen: maxLength(13),
  //   },
  // },

  data() {
    return {
      // ──────────────────────────────────────────────────────────────
      // Google Sign-In state
      // ──────────────────────────────────────────────────────────────
      googleDone: false,
      googleEmail: "",
      googleUid: "", // Store uid from popup to avoid timing bug
      badgeNumber: null,
      showPin: false,
      loading: false,
      domainBlocked: false,
      signInFailed: false,
      pinError: false,
      disabledAdmin: false

      // ════════════════════════════════════════════════════════════════
      //  Phone/SMS state (handled by mixin previously)
      // ════════════════════════════════════════════════════════════════
      // phone: '',
      // verifyCode: '',
      // value: String, // for password show/hide toggle
    };
  },

  methods: {
    // ──────────────────────────────────────────────────────────────────
    //  Google Sign-In with @gooday.io domain restriction
    // ──────────────────────────────────────────────────────────────────
    async signInWithGoogle() {
      this.loading = true;
      this.domainBlocked = false;
      this.signInFailed = false;

      const provider = new firebase.auth.GoogleAuthProvider();
      // Google account picker to show only @gooday.io accounts
      provider.setCustomParameters({ hd: "gooday.io" });

      try {
        const result = await firebase.auth().signInWithPopup(provider);
        const { email } = result.user;

        // sign out non-gooday.io accounts immediately
        if (!email.endsWith("@gooday.io")) {
          await firebase.auth().signOut();
          this.domainBlocked = true;
          this.loading = false;
          return;
        }

        this.googleEmail = email;
        this.googleUid = result.user.uid; // CRITICAL: Store uid immediately
        this.googleDone = true;
      } catch (error) {
        // User closed popup — don't show error (expected behavior)
        if (error.code !== "auth/popup-closed-by-user") {
          this.signInFailed = true;
        }
      }

      this.loading = false;
    },

    // ──────────────────────────────────────────────────────────────────
    // Confirm pin after Google auth
    // ──────────────────────────────────────────────────────────────────
    async confirmPin() {
      this.loading = true;
      this.pinError = false;
      this.disabledAdmin = false;
      // Pass uid directly from popup result instead of relying on currentUser
      await this.$store.dispatch("auth/loadUserData", {
        uid: this.googleUid,
        badgeNumber: this.badgeNumber
      });
      if (!this.$store.getters["auth/isAuthenticated"]) {
        this.pinError = true;
      }
      this.loading = false;
    }

    // ════════════════════════════════════════════════════════════════════
    // Phone/SMS authentication methods
    // ════════════════════════════════════════════════════════════════════
    // smsAuthenticate() {
    //   this.$store.dispatch('auth/smsAuthenticate', this.phone);
    // },
    // signIn() {
    //   this.$store.dispatch('auth/signIn', {
    //     verifyCode: this.verifyCode,
    //     badgeNumber: this.badgeNumber,
    //   });
    // },
  },

  computed: {
    // ════════════════════════════════════════════════════════════════════
    //  Phone validation computed properties (from vuelidate)
    // ════════════════════════════════════════════════════════════════════
    // phoneErrors() {
    //   const errors = [];
    //   if (!this.$v.phone.$dirty) return errors;
    //   if (!this.$v.phone.required) errors.push('Phone number is required');
    //   if (!this.$v.phone.minLen || !this.$v.phone.maxLen) {
    //     errors.push('Phone number should be 13 digits including the + sign');
    //   }
    //   return errors;
    // },
    // okSignin() {
    //   return !this.$v.$invalid;
    // },
  }
};
</script>
